import React from 'react'
import { faDesktop, faCoffee, faPlaneDeparture, faCarAlt, faPalette, faMusic, faBookOpen, faGamepad } from '@fortawesome/free-solid-svg-icons'
import { ThemeHeading } from '../../components/common/ThemeHeading'
import { InterestBox } from './interestbox'

export default function MyInterest(props) {
    return (
        <section className="interests-wrapper site-margin wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.7s"
            id="interest">
            <div className="container">
               <ThemeHeading heading="My Interests" />
               <div className="row">
                    <InterestBox Icon={faDesktop} title="Developing" />
                    <InterestBox Icon={faCoffee} title="Coffee" />
                    <InterestBox Icon={faPlaneDeparture} title="Traveling" />
                    <InterestBox Icon={faCarAlt} title="Cars" />
                    <InterestBox Icon={faPalette} title="Painting" />
                    <InterestBox Icon={faMusic} title="Music" />
                    <InterestBox Icon={faBookOpen} title="Reading" />
                    <InterestBox Icon={faGamepad} title="Games" />
               </div>
            </div>
         </section>
    )
}